
































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import router from "../router";
import ReziseSensor from "css-element-queries/src/ResizeSensor";
import VuePlotly from '@statnett/vue-plotly'
import { home } from '../config/home'


export default Vue.extend({
    name: 'Home',
    metaInfo: {
        title: 'Weather the Storm',
        meta : [
            {
                name: 'description',
                content : 'Thunderstorms and Cyclones are a part of life in Australia. Use this site to learn how a house can weather the storm through maintenance, window protection and retrofitting. Understand wind loads and the ‘tie-down chain’. Created by the Cyclone Testing Station at James Cook University.'
            },
            {
                name: 'keywords',
                content : 'cyclones, thunderstorms, Australia, houses, retrofitting, storm preparation, builders, homeowners, cyclone, weather, storm, protection'
            }
        ]
    },
    components: {
        VuePlotly
    },

    data: () => ({
        "data": [
            {
                "line": {
                    "color": "rgb(228, 134, 61)",
                    "shape": "spline",
                    "width": 4
                },
                "meta": {
                    "columnNames": {
                        "x": "A",
                        "y": "B"
                    }
                },
                "mode": "lines",
                "name": "A well-maintained house",
                "type": "scatter",
                "xsrc": "saira_vq:0:4d4b9d",
                "x": [
                    " ",
                    "Wind\n  speed km/h",
                    "108",
                    "112",
                    "115",
                    "119",
                    "122",
                    "126",
                    "130",
                    "133",
                    "137",
                    "140",
                    "144",
                    "148",
                    "151",
                    "155",
                    "158",
                    "162",
                    "166",
                    "169",
                    "173",
                    "176",
                    "180",
                    "184",
                    "187",
                    "191",
                    "194",
                    "198",
                    "202",
                    "205",
                    "209",
                    "212",
                    "216",
                    "220",
                    "223",
                    "227",
                    "230",
                    "234",
                    "238",
                    "241",
                    "245",
                    "248",
                    "252",
                    "256",
                    "259",
                    "263",
                    "266",
                    "270",
                    "274",
                    "277",
                    "281",
                    "284",
                    "288",
                    "292",
                    "295",
                    "299",
                    "302",
                    "306",
                    "310",
                    "313",
                    "317",
                    "320",
                    "324"
                ],
                "ysrc": "saira_vq:0:48ba65",
                "y": [
                    "Level 1  Well maintained house",
                    "Level 1  Well maintained house",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.001",
                    "0.002",
                    "0.007",
                    "0.015",
                    "0.025",
                    "0.043",
                    "0.066",
                    "0.087",
                    "0.117",
                    "0.150",
                    "0.185",
                    "0.223",
                    "0.261",
                    "0.299",
                    "0.336",
                    "0.375",
                    "0.408",
                    "0.448",
                    "0.491",
                    "0.537",
                    "0.576",
                    "0.617",
                    "0.660",
                    "0.696",
                    "0.728",
                    "0.760",
                    "0.792",
                    "0.815",
                    "0.835",
                    "0.852",
                    "0.865",
                    "0.874",
                    "0.880",
                    "0.882",
                    "0.884",
                    "0.887",
                    "0.889",
                    "0.892",
                    "0.893",
                    "0.894",
                    "0.894",
                    "0.894",
                    "0.894",
                    "0.894",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895",
                    "0.895"
                ],
                "error_x": {
                    "type": "percent",
                    "color": "rgb(228, 134, 61)",
                    "value": 10,
                    "width": 4,
                    "visible": false,
                    "symmetric": true,
                    "thickness": 2
                },
                "hoveron": "fills",
                "hoverinfo": "none",
                "hovertemplate": ""
            },
            {
                "line": {
                    "color": "rgb(247, 221, 103)",
                    "shape": "spline",
                    "width": 4,
                    "smoothing": 1
                },
                "meta": {
                    "columnNames": {
                        "x": "A",
                        "y": "C"
                    }
                },
                "mode": "lines",
                "name": "Maintenance and the addition of window and door protection ",
                "type": "scatter",
                "xsrc": "saira_vq:0:4d4b9d",
                "x": [
                    " ",
                    "Wind\n  speed km/h",
                    "108",
                    "112",
                    "115",
                    "119",
                    "122",
                    "126",
                    "130",
                    "133",
                    "137",
                    "140",
                    "144",
                    "148",
                    "151",
                    "155",
                    "158",
                    "162",
                    "166",
                    "169",
                    "173",
                    "176",
                    "180",
                    "184",
                    "187",
                    "191",
                    "194",
                    "198",
                    "202",
                    "205",
                    "209",
                    "212",
                    "216",
                    "220",
                    "223",
                    "227",
                    "230",
                    "234",
                    "238",
                    "241",
                    "245",
                    "248",
                    "252",
                    "256",
                    "259",
                    "263",
                    "266",
                    "270",
                    "274",
                    "277",
                    "281",
                    "284",
                    "288",
                    "292",
                    "295",
                    "299",
                    "302",
                    "306",
                    "310",
                    "313",
                    "317",
                    "320",
                    "324"
                ],
                "ysrc": "saira_vq:0:f3d9df",
                "y": [
                    "Level 2 Window and door\n  protection",
                    "Level 2 Window and door\n  protection",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.001",
                    "0.001",
                    "0.006",
                    "0.011",
                    "0.018",
                    "0.027",
                    "0.040",
                    "0.052",
                    "0.067",
                    "0.084",
                    "0.106",
                    "0.132",
                    "0.158",
                    "0.183",
                    "0.211",
                    "0.244",
                    "0.274",
                    "0.311",
                    "0.354",
                    "0.402",
                    "0.444",
                    "0.490",
                    "0.543",
                    "0.598",
                    "0.649",
                    "0.699",
                    "0.749",
                    "0.785",
                    "0.815",
                    "0.840",
                    "0.858",
                    "0.869",
                    "0.875",
                    "0.878",
                    "0.880",
                    "0.882",
                    "0.885",
                    "0.887",
                    "0.889",
                    "0.890",
                    "0.890",
                    "0.890",
                    "0.890",
                    "0.890",
                    "0.890",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891",
                    "0.891"
                ],
                "hoveron": "fills",
                "hoverinfo": "none",
                "autocolorscale": true
            },
            {
                "line": {
                    "color": "rgb(164, 223, 89)",
                    "shape": "spline",
                    "width": 4
                },
                "meta": {
                    "columnNames": {
                        "x": "A",
                        "y": "F"
                    }
                },
                "mode": "lines",
                "name": "Maintenance and a roof tie-down retrofit",
                "type": "scatter",
                "xsrc": "saira_vq:0:4d4b9d",
                "x": [
                    " ",
                    "Wind\n  speed km/h",
                    "108",
                    "112",
                    "115",
                    "119",
                    "122",
                    "126",
                    "130",
                    "133",
                    "137",
                    "140",
                    "144",
                    "148",
                    "151",
                    "155",
                    "158",
                    "162",
                    "166",
                    "169",
                    "173",
                    "176",
                    "180",
                    "184",
                    "187",
                    "191",
                    "194",
                    "198",
                    "202",
                    "205",
                    "209",
                    "212",
                    "216",
                    "220",
                    "223",
                    "227",
                    "230",
                    "234",
                    "238",
                    "241",
                    "245",
                    "248",
                    "252",
                    "256",
                    "259",
                    "263",
                    "266",
                    "270",
                    "274",
                    "277",
                    "281",
                    "284",
                    "288",
                    "292",
                    "295",
                    "299",
                    "302",
                    "306",
                    "310",
                    "313",
                    "317",
                    "320",
                    "324"
                ],
                "ysrc": "saira_vq:0:5dd590",
                "y": [
                    "Level 3 - Full roof retrofit",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.001",
                    "0.002",
                    "0.003",
                    "0.004",
                    "0.006",
                    "0.008",
                    "0.020",
                    "0.032",
                    "0.047",
                    "0.064",
                    "0.085",
                    "0.106",
                    "0.126",
                    "0.148",
                    "0.169",
                    "0.195",
                    "0.221",
                    "0.251",
                    "0.283",
                    "0.314",
                    "0.348",
                    "0.373",
                    "0.396",
                    "0.415",
                    "0.430",
                    "0.443",
                    "0.464",
                    "0.484",
                    "0.504",
                    "0.523",
                    "0.543",
                    "0.554",
                    "0.566",
                    "0.577",
                    "0.588",
                    "0.600",
                    "0.611",
                    "0.625",
                    "0.638",
                    "0.655",
                    "0.674",
                    "0.689",
                    "0.704",
                    "0.718",
                    "0.732",
                    "0.743",
                    "0.757",
                    "0.767",
                    "0.777",
                    "0.784",
                    "0.789",
                    "0.790"
                ],
                "hoveron": "fills",
                "hoverinfo": "none",
                "stackgroup": null
            },
            {
                "line": {
                    "color": "rgb(84, 207, 84)",
                    "shape": "spline",
                    "width": 4
                },
                "meta": {
                    "columnNames": {
                        "x": "A",
                        "y": "G"
                    }
                },
                "mode": "lines",
                "name": "Maintenance, a roof tie-down retrofit and window and door protection    ",
                "type": "scatter",
                "xsrc": "saira_vq:0:4d4b9d",
                "x": [
                    " ",
                    "Wind\n  speed km/h",
                    "108",
                    "112",
                    "115",
                    "119",
                    "122",
                    "126",
                    "130",
                    "133",
                    "137",
                    "140",
                    "144",
                    "148",
                    "151",
                    "155",
                    "158",
                    "162",
                    "166",
                    "169",
                    "173",
                    "176",
                    "180",
                    "184",
                    "187",
                    "191",
                    "194",
                    "198",
                    "202",
                    "205",
                    "209",
                    "212",
                    "216",
                    "220",
                    "223",
                    "227",
                    "230",
                    "234",
                    "238",
                    "241",
                    "245",
                    "248",
                    "252",
                    "256",
                    "259",
                    "263",
                    "266",
                    "270",
                    "274",
                    "277",
                    "281",
                    "284",
                    "288",
                    "292",
                    "295",
                    "299",
                    "302",
                    "306",
                    "310",
                    "313",
                    "317",
                    "320",
                    "324"
                ],
                "ysrc": "saira_vq:0:46dec6",
                "y": [
                    "Level 2 + Level 3",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.000",
                    "0.001",
                    "0.001",
                    "0.002",
                    "0.003",
                    "0.004",
                    "0.005",
                    "0.010",
                    "0.015",
                    "0.021",
                    "0.030",
                    "0.041",
                    "0.049",
                    "0.058",
                    "0.072",
                    "0.086",
                    "0.104",
                    "0.124",
                    "0.144",
                    "0.162",
                    "0.184",
                    "0.201",
                    "0.216",
                    "0.234",
                    "0.251",
                    "0.262",
                    "0.280",
                    "0.300",
                    "0.321",
                    "0.340",
                    "0.358",
                    "0.383",
                    "0.407",
                    "0.435",
                    "0.461",
                    "0.491",
                    "0.509",
                    "0.527",
                    "0.547",
                    "0.573",
                    "0.603",
                    "0.633",
                    "0.660",
                    "0.683",
                    "0.699",
                    "0.713",
                    "0.724",
                    "0.739",
                    "0.751",
                    "0.762",
                    "0.771",
                    "0.776",
                    "0.777"
                ],
                "hoveron": "fills",
                "fillcolor": "rgba(129, 218, 153, 0.5)",
                "groupnorm": "",
                "hoverinfo": "none",
                "stackgaps": "infer zero",
                "connectgaps": false,
                "orientation": "v",
                "autocolorscale": true
            }
        ],
        "layout": {
            "autosize" : true,

            "height" : 600,
            "title": {
                "text": "Damage Index vs. Wind Speed"
            },
            "xaxis": {
                "type": "linear",
                "range": [
                    100,
                    250
                ],
                "title": {
                    "text": "0.2 Sec Gust Wind Speed (km/h)"
                },
                "tickmode": "auto",
                "autorange": false
            },
            "yaxis": {
                "type": "linear",
                "range": [
                    -0.1,
                    1
                ],
                "title": {
                    "text": "Damage Index"
                },
                "autorange": true
            },
            "images": [],
            "legend": {
                "orientation": "h",
                "y" : -0.2
            },
            "shapes": [
                {
                    "x0": 100.25842696629213,
                    "x1": 108.8876404494382,
                    "y0": 0,
                    "y1": 0.19999999999999998,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.3,
                    "fillcolor": "rgb(178, 240, 132)"
                },
                {
                    "x0": 100.25763864591973,
                    "x1": 108.8876404494382,
                    "y0": 0.20000911286780848,
                    "y1": 0.49999330259112873,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.3,
                    "fillcolor": "rgb(227, 218, 50)"
                },
                {
                    "x0": 100.25763864591973,
                    "x1": 108.87134003518145,
                    "y0": 0.5,
                    "y1": 1,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.3,
                    "fillcolor": "rgb(232, 77, 77)"
                },
               /* {
                    "x0": 100,
                    "x1": 125,
                    "y0": -0.03,
                    "y1": -0.1,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.1,
                    "fillcolor": "rgb(54, 128, 191)"
                },
                {
                    "x0": 125,
                    "x1": 165,
                    "y0": -0.03,
                    "y1": -0.1,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.2,
                    "fillcolor": "rgb(54, 128, 191)"
                },
                {
                    "x0": 165,
                    "x1": 225,
                    "y0": -0.03,
                    "y1": -0.1,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.3,
                    "fillcolor": "rgb(54, 128, 191)"
                },
                {
                    "x0": 225,
                    "x1": 250,
                    "y0": -0.03,
                    "y1": -0.1,
                    "line": {
                        "color": "#444444",
                        "width": 0
                    },
                    "opacity": 0.4,
                    "fillcolor": "rgb(54, 128, 191)"
                }*/
            ],

            "dragmode": "select",
            "hovermode": false,
            "annotations": [
                {
                    "x": 104,
                    "y": 0.0937254062362758,
                    "ax": -193,
                    "ay": -30,
                    "text": "MINOR",
                    "showarrow": false,
                    "textangle": -90
                },
                {
                    "x": 104,
                    "y": 0.3374429073342117,
                    "text": "MODERATE",
                    "showarrow": false,
                    "textangle": -90
                },
                {
                    "x": 104,
                    "y": 0.7230289161639276,
                    "text": "SEVERE",
                    "showarrow": false,
                    "textangle": -90
                },
               /* {
                    "x": 112,
                    "y": -0.065,
                    "text": "<b>CAT 1</b>",
                    "showarrow": false
                },
                {
                    "x": 145.92696629213484,
                    "y": -0.065,
                    "text": "<b>CAT 2</b>",
                    "showarrow": false
                },
                {
                    "x": 196.48876404494382,
                    "y": -0.065,
                    "text": "<b>CAT 3</b>",
                    "showarrow": false
                },
                {
                    "x": 237.78089887640448,
                    "y": -0.065,
                    "text": "<b>CAT 4</b>",
                    "showarrow": false
                }*/
                {
                    "x": 162,
                    "y": 0,
                    "ax": 0,
                    "ay": -250,
                    "arrowsize": 2,
                    "arrowwidth": 1,
                    "text": "Cyclone <br>Yasi <br>\nat Townsville"
                },
                {
                    "x": 178,
                    "y": 0,
                    "ax": 0,
                    "ay": -200,
                    "arrowsize": 2,
                    "arrowwidth": 1,
                    "text": "Cyclone <br>Debbie <br>\nat Bowen"
                },
                {
                    "x": 204,
                    "y": 0,
                    "ax": 0,
                    "ay": -250,
                    "arrowsize": 2,
                    "arrowwidth": 1,
                    "text": "Cyclone <br>Yasi <br>\nat Innisfail"
                }
            ]
        },
        "frames": [],
        "home" : home,
        options: {
            "autoresize": true,
            "autosize": true,
            "autosizable": true,
            "reponsive": true
        },
        autoresize: true,
        articles: [
            {
                src: 'trees.jpg',
                title: 'The Effect of Winds',
                text: 'Understand wind loads and learn where a house gets its strength.',
                link: 'wind'
            },
            {
                src: 'house.jpeg',
                title: 'Getting Approvals',
                text: 'Get approvals from authorities and contact a licensed builder.',
                link: 'approvals'
            },
            {
                src: 'builder.jpeg',
                title: 'Resources for Professionals',
                text: 'Here are some codes, standards, and videos for building professionals.',
                link: 'resources'
            },
        ],
        examples: [
            {
                src: 'damage-examples/minor.jpg',
                title: 'Minor Damage',

            },
            {
                src: 'damage-examples/moderate.jpg',
                title: 'Moderate Damage',

            },
            {
                src: 'damage-examples/severe.jpg',
                title: 'Severe Damage',

            },
        ],
        videos: [
            {
                src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                title: 'Get Approvals and Contact Your Builder',
                text: 'Get approvals from authorities and contact a licensed builder.',
                link: 'approvals'
            },

            {
                src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                title: 'Understand How Winds Affect Houses',
                text: 'Understand wind loads and learn about the principles of retrofitting.',
                link: 'wind'
            },
            {
                src: 'https://www.youtube.com/embed/h5WAzQxJg7w',
                title: 'Resources for Building Professionals',
                text: 'Here are some resources for building professionals.',
                link: 'resources'
            },
        ],
        features: [
            {
                icon: 'mdi-hammer',
                title: 'Level 1',
                subtitle: 'General Maintenance',
                text: 'Check for rust, termites, rot and moisture.',
                link: 'maintenance',
                highlight: false,
                elevation: 0,
                color: "grey lighten-1"
            },
            {
                icon: 'mdi-window-open',
                title: 'LEVEL 2',
                subtitle: 'Window and Door Protection',
                text: 'Protect your windows and doors from debris and water ingress.',
                link: 'window',
                highlight: false,
                elevation: 0,
                color: "grey darken-1"
            },
            {
                icon: 'mdi-hammer-screwdriver',
                title: 'Level 3',
                subtitle: 'Roof Tie-Down Retrofit: Try to reach this level!',
                text: 'Select features of your house to get customised retrofitting details.',
                link: 'select',
                highlight: true,
                elevation: 0,
                color: "grey darken-3"
            },
            /*{
                icon: 'mdi-home-roof',
                title: 'LEVEL 4',
                subtitle: 'Roof and Wall Tie-Down Retrofit',
                text: 'Coming Up Soon.',
                link: 'todo',
                highlight: false
            },
            {
                icon: 'mdi-playlist-check',
                title: 'Select a Level of Retrofitting',
                text: 'Some retrofitting tasks should be performed before others.',
                link: 'select/levels'
            },
            {
                icon: 'mdi-home',
                title: 'Select Your House-Type to get Customised Retrofit Details',
                text: 'Select the category your house falls in. This will help you decide which retrofits are suitable.',
                link: 'select'
            },
            {
                icon: 'mdi-playlist-check',
                title: 'Get Approvals and Contact Your Builder',
                text: 'Get approvals from authorities and contact a licensed builder.',
                link: 'select/approvals'
            },
            {
                icon: 'mdi-playlist-check',
                title: 'Get Approvals and Contact Your Builder',
                text: 'Get approvals from authorities and contact a licensed builder.',
                link: 'select/approvals'
            },*/
           /*,
            {
                icon: 'mdi-weather-windy',
                title: 'Understand Wind Loads and House Structures',
                text: 'Understand the relationship between wind loads and house structures.',
                link: 'select/wind'
            },
            {
                icon: 'mdi-ruler-square',
                title: 'Understand the Principles of Retrofitting',
                text: 'In order to protect your house you must understand the basics.',
                link: 'select/principles'
            }*/
        ],
        partners: [
            {
                src: 'geo-logo.jpg',
                ratio: 3.41,
                title: 'Get Approvals and Contact Your Builder',
                text: 'Get approvals from authorities and contact a licensed builder.',
                link: 'select/approvals'
            },
            {
                src: 'bush-logo.jpg',
                title: 'Window and Door Protection',
                text: 'Protecting windows and door can reduce the risk of internal pressurization and water ingress.',
                link: 'resources',
                ratio: 2.68
            },
          /*  {
                src: 'cts-logo.jpg',
                title: 'Contact Your Builder',
                text: 'Funding and incentive schemes.',
                link: 'select/approvals',
                ratio: 2.32
            },*/
        ],
    }),
    methods: {
        gotoSelect() {
            router.push('/select').catch(err => {
                return err
            })
        },
        gotoHome() {
            router.push('/').catch(err => {
                return err
            })
        },
        gotoWind() {
            router.push('/wind').catch(err => {
                return err
            })
        },
        gotoResources() {
            router.push('/resources').catch(err => {
                return err
            })

        }
    },
    computed: {
        minHeight () {
            const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

            return `calc(${height} - ${this.$vuetify.application.top}px)`
        },
    }

})
